import BasicLayout from '@/layouts/basic-layout'

const prefix = 'accounts-tarting-statement-'
export default {
  path: '/report-center/accounts-tarting-statement',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {title: '挞定报表'},
      component: () => import('@/pages/report-center/accounts-tarting-statement/index')
    },
    {
      path: 'detail-edit/:id',
      name: `${prefix}edit`,
      auth: ['hidden'],
      meta: {title: '挞定报表编辑'},
      component: () => import('@/pages/report-center/accounts-tarting-statement/detail-edit')
    },

    {
      path: 'detail-view/:id',
      name: `${prefix}view`,
      auth: ['hidden'],
      meta: {title: '挞定报表详情'},
      component: () => import('@/pages/report-center/accounts-tarting-statement/detail-view')
    }
  ]
}
